// Mock data for Kamotors Solutions

export const businessInfo = {
  name: "K&A Motors Tech Solutions",
  tagline: "Expert Electronic Diagnostics & ECU Programming",
  whatsapp: "+503 7315-7851",
  email: "k.atechsolutions12@gmail.com",
  squareSite: "https://kamotorssolutions.square.site",
  hours: {
    weekdays: "Monday - Friday: 9:00 AM - 5:00 PM",
    saturday: "Saturday: Closed",
    sunday: "Sunday: Closed"
  },
  facebookUrl: "https://www.facebook.com/kamotorsf1"
};

export const services = [
  { id: 1, title: "services_items.diag.title", description: "services_items.diag.desc", icon: "scan" },
  { id: 2, title: "services_items.ecu.title", description: "services_items.ecu.desc", icon: "cpu" },
  { id: 3, title: "services_items.elec.title", description: "services_items.elec.desc", icon: "zap" },
  { id: 4, title: "services_items.mod.title", description: "services_items.mod.desc", icon: "settings" },
  { id: 5, title: "services_items.sens.title", description: "services_items.sens.desc", icon: "gauge" },
  { id: 6, title: "services_items.batt.title", description: "services_items.batt.desc", icon: "cable" },
  { id: 7, title: "services_items.oil.title", description: "services_items.oil.desc", icon: "droplet" }
];
export const testimonials = [
  {
    id: 1,
    name: "John Martinez",
    rating: 5,
    text: "reviews.user1.text",
    date: "reviews.user1.date"
  },
  {
    id: 2,
    name: "Sarah Johnson",
    rating: 5,
    text: "reviews.user2.text",
    date: "reviews.user2.date"
  },
  {
    id: 3,
    name: "Michael Chen",
    rating: 5,
    text: "reviews.user3.text",
    date: "reviews.user3.date"
  }
];

export const faqs = [
  {
    id: 1,
    question: "How long does a diagnostic take?",
    answer: "Most electronic diagnostics take 1-2 hours depending on the complexity of the issue. We'll provide an estimate when you book."
  },
  {
    id: 2,
    question: "Do you work on all vehicle makes?",
    answer: "Yes! We have the latest diagnostic equipment and software to work on all domestic and import vehicles."
  },
  {
    id: 3,
    question: "What is ECU programming?",
    answer: "ECU (Engine Control Unit) programming involves updating or modifying your vehicle's computer software to optimize performance, fix issues, or restore factory settings."
  },
  {
    id: 4,
    question: "Do you offer warranty on your work?",
    answer: "Yes, we provide a warranty on all our diagnostic and programming services. Contact us for specific warranty details."
  }
];

// Mock function to simulate appointment booking
export const mockBookAppointment = (appointmentData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock appointment booked:', appointmentData);
      resolve({
        success: true,
        message: 'Appointment request received! We will contact you shortly to confirm.',
        appointmentId: `APT-${Date.now()}`
      });
    }, 1000);
  });
};
